import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import { MOBILE } from './values';


export default function Mobile(props, context) {
  const isMobile = context.initialBreakpoint === MOBILE;

  return isMobile ? props.children : null;
}

Mobile.contextTypes = {
  initialBreakpoint: breakpointPropTypes(),
};
